import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Related Articles customisation
 * Returns all related articles customization fields (heading, content, subtext)
 */
export const useRelatedArticlesCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.ARTICLE,
    sectionKey: PUI.ARTICLES_SECTION_KEYS.RELATED_ARTICLES,
    blockKey: PUI.ARTICLES_BLOCK_KEYS.BODY_SECTION,
  });

  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);

  return {
    isVisible,
    textColor,
    subTextColor,
    backgroundColor,
    borderColor,
  };
};
